import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { getSession, getRole } from '../../utils/utils';

const ProtectedRoute = ({ token, roleAccess, subscription, profileComplete }) => {
    const navigate = useNavigate();
    const role = getRole();
    const session = getSession();

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let redirectPath = null;

        // Rutas públicas (token = false)
        if (!token) {
            if (session) {
                redirectPath = '/PanelDeControl'; // Si hay sesión, redirige al dashboard
            }
        }
        // Rutas protegidas (token = true)
        else {
            if (!session) {
                redirectPath = '/'; // Si no hay sesión, redirige al login
            } else if (roleAccess && !roleAccess.includes(role)) {
                redirectPath = '/'; // Si el rol no tiene acceso, redirige al login
            } else if (subscription && !session.subscription) {
                redirectPath = '/'; // Si no hay suscripción, redirige al login
            } else if (profileComplete && !session.personal_data?.born_date) {
                redirectPath = '/Perfil'; // Si el perfil no está completo, redirige a completarlo
            }
        }

        if (redirectPath) {
            navigate(redirectPath, { replace: true });
        } else {
            setLoading(false);
        }
    }, [token, session, roleAccess, subscription, profileComplete]);

    if (loading) return null; // Evita mostrar la pantalla en blanco mientras evalúa

    return <Outlet />;
};

export default ProtectedRoute;